module.exports = __webpack_public_path__ + "media/components/common/formParts/img/geo-bg-img-top-8ed27d24741d0ace81969aa5fafb6150.jpg";